export function campaignMetrics(c){
  const gasto = Number(c.gasto)||0;
  const receita = Number(c.receita)||0;
  const cliques = Number(c.cliques)||0;
  const impressoes = Number(c.impressoes)||0;
  const conversoes = Number(c.conversoes)||0;
  return {
    roas: gasto>0 ? receita/gasto : 0,
    roiPct: gasto>0 ? ((receita-gasto)/gasto)*100 : 0,
    cpa: conversoes>0 ? gasto/conversoes : 0,
    ctrPct: impressoes>0 ? (cliques/impressoes)*100 : 0,
    cpc: cliques>0 ? gasto/cliques : 0
  };
}
